<template>
  <div class="screen-content">
    <div class="screen-select" :style="{'--adaption-num': info.adaptionNum }">
      <div class="screen-select-item" v-for="(item, index) in info.tagList" :style="getStyleInfo" :key="index">
        <div class="screen-select-item-title">
          <styleModule :dataInfo="item.styleInfo" />
          <div v-if="item.bgSelect" class="bg-info">
            <img :src="getImgUrl(item)" alt="">
          </div>
        </div>
        <div class="screen-select-item-content">
          <draggable v-model="userList[item.id]" class="user-list" animation="300" group="user">
            <div class="user-list-item" v-for="(user, userIndex) in userList[item.id]" :key="userIndex">
              {{ user }}
            </div>
          </draggable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import styleModule from '@/components/schoolInstrument/common/styleModule.vue'
import draggable from 'vuedraggable'
export default {
  // 组件名称
  name: 'screenSelect',
  // 组件参数 接收来自父组件的数据
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },
  // 局部注册的组件
  components: {
    styleModule,
    draggable
  },
  // 组件状态值
  data() {
    return {
      activeId: -1,
      userList: {}
    }
  },
  // 计算属性
  computed: {
    getStyleInfo() {
      let width = ''
      let height = this.info.height + 'px'
      if (this.info.adaption === 'yes') {
        const num = this.info.adaptionNum
        width = `${100 / num}%`
      } else {
        width = this.info.width + 'px'
      }
      return { width, height }
    },
  },
  mounted() {
    const li = this.info.tagList
    li.forEach(item => {
      this.userList[item.id] = [1,2,3,4,5,6]
    })
  },
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    getImgUrl(item) {
      const bgSelect = item.bgSelect
      if (bgSelect.includes('img-')) {
        return this.$imgurl + bgSelect
      } else if (bgSelect) {
        return 'https://bigdata.topeti.com/PCRepository/middleground/home/icon/' + bgSelect
      } else {
        return ''
      }
    }
  },
}
</script>

<style scoped lang="scss">
.screen-content {
  padding: 15px 10px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.screen-select {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap; 
  $adaptionNum: var(--adaption-num);
  &-item {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 0 5px;
    overflow: hidden;
    &-title {
      width: 100%;
      position: relative;
      z-index: 2;
      overflow: hidden;
      margin-bottom: 10px;
      .bg-info {
        img {
          width: 100%;
        }
      }
    }
    &-content {
      display: flex;
      flex-wrap: wrap;
      flex: 1;
      background-color: #F0F0F3;
      border-radius: 8px;
      .user-list {
        display: flex;
        justify-content: start;
        align-content: start;
        flex-wrap: wrap;
        height: 100%;
        width: 100%;
        &-item {
          padding: 5px 8px;
          background-color: #4e86ff;
          color: #fff;
          border-radius: 4px;
          margin: 5px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
